<div class="gap-4 flex flex-col items-start self-stretch">
  <ng-content></ng-content>
</div>
